const ADMIN_TYPES = new Set(['admin', 'super_admin', 'sub_admin']);

export function isAdminType(adminType: string | null | undefined): boolean {
  return Boolean(adminType && ADMIN_TYPES.has(adminType));
}
